import { Exhibition } from "./exhibition";
import { RodeoEventRun } from "./rodeoEventRun";

export class RodeoEventSchedule {
    id: number;
    name: string;

    scheduledDate: string;
    priority: number;
    runs: RodeoEventRun[];
    scheduleGroupId: number = 0;
    rodeoEventId: number;

    minSize: number = 6;
    maxSize: number = 10;
    capPreferences: boolean;
    blockPreference: boolean;

    firstPrefCounts: number = 0;
    secondPrefCounts: number = 0;

    stockPublished: boolean;
    published: boolean;

    constructor() {
        this.runs = [];
    }
}


// WEBPACK FOOTER //
// ./src/model/rodeoEventSchedule.ts